import DateFormat from '../common/dateFormat/DateFormat';

const INITIAL_STATE = {
	aguardando: false,
	registro: {},
	modoTela: 'lista',
	filtro: {
		data_inicial: DateFormat.formatarDataSqlParaTela(DateFormat.getDataAnterior(30)),
		data_final: DateFormat.formatarDataSqlParaTela(DateFormat.getDataAtual())
	},
	lista: [],
	listaTipo: [],
	listaEvento: [],
	listaUnidade: []
};

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
		case 'ACESSORIO_ENTRADA_MODO_TELA':
            return { ...state,
				modoTela: action.payload.modo,
				registro: action.payload.registro
			};

		case 'ACESSORIO_ENTRADA_SET_AGUARDANDO':
            return { ...state,
				aguardando: action.payload
			};

        case 'ACESSORIO_ENTRADA_FILTRO':
            return {
				...state,
				filtro: action.payload.filtro
			};

        case 'ACESSORIO_ENTRADA_LISTADO':
            return {
				...state,
				lista: action.payload.data
			};

        case 'ACESSORIO_ENTRADA_TIPO_SELECT_LISTADO':
			return {
				...state,
				listaTipo: action.payload.data
			};

        case 'ACESSORIO_ENTRADA_EVENTO_SELECT_LISTADO':
			return {
				...state,
				listaEvento: action.payload.data
			};
			
        case 'ACESSORIO_ENTRADA_UNIDADE_SELECT_LISTADO':
			return {
				...state,
				listaUnidade: action.payload.data
			};

        default:
            return state;
    }
}
